module.exports = __webpack_public_path__ + "static/sketch-notes-8d1707881b91662d17065337a5af8ab6.jpg";